import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppShell } from './shared/layout/AppShell';
import ProtectedRoute from './components/auth/ProtectedRoute';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const ProductManagement = lazy(() => import('./pages/plm/ProductManagement'));
const DocumentManagement = lazy(() => import('./pages/pdm/DocumentManagement'));
const BomManagement = lazy(() => import('./pages/pdm/BomManagement'));
const InventoryManagement = lazy(() => import('./pages/erp/InventoryManagement'));
const SupplyChain = lazy(() => import('./pages/erp/SupplyChain'));
const Finance = lazy(() => import('./pages/erp/Finance'));
const ChangeManagement = lazy(() => import('./pages/ecm/ChangeManagement'));
const ChangeOrders = lazy(() => import('./pages/ecm/ChangeOrders'));
const RevisionControl = lazy(() => import('./pages/ecm/RevisionControl'));
const Settings = lazy(() => import('./pages/Settings'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const UserManagement = lazy(() => import('./pages/admin/UserManagement'));
const AuthCallback = lazy(() => import('./pages/auth/AuthCallback'));
const AuthError = lazy(() => import('./pages/auth/AuthError'));
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'));

function RouteLoadingFallback() {
  return (
    <div className="flex min-h-[320px] items-center justify-center">
      <div className="glass-panel rounded-[28px] px-6 py-5 text-center">
        <div className="mx-auto mb-3 h-8 w-8 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
        <p className="text-sm font-medium text-content">Loading workspace</p>
        <p className="mt-1 text-xs text-content-muted">Fetching the next route bundle.</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Suspense fallback={<RouteLoadingFallback />}>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/auth/error" element={<AuthError />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />

          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppShell>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/plm/products" element={<ProductManagement />} />
                    <Route path="/pdm/documents" element={<DocumentManagement />} />
                    <Route path="/pdm/bom" element={<BomManagement />} />
                    <Route path="/erp/inventory" element={<InventoryManagement />} />
                    <Route path="/erp/supply-chain" element={<SupplyChain />} />
                    <Route path="/erp/finance" element={<Finance />} />
                    <Route path="/ecm/changes" element={<ChangeManagement />} />
                    <Route path="/ecm/orders" element={<ChangeOrders />} />
                    <Route path="/ecm/revisions" element={<RevisionControl />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/users" element={<UserManagement />} />
                  </Routes>
                </AppShell>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
